import { createFileRoute } from '@tanstack/react-router';
import { ConfigPushHistoryPage } from '@/pages/chain/ConfigPushHistoryPage';
import { requireAnyPermission } from '@/lib/route-guards/permission-guard';
import { z } from 'zod';

const searchSchema = z.object({
	page: z.number().optional(),
	configType: z.enum(['FORM_TEMPLATE', 'SERVICE_TYPE', 'QUICK_LINK', 'COMPETENCE_TYPE']).optional(),
});

export const Route = createFileRoute('/_authenticated/_app/chain/config-pushes')({
	beforeLoad: ({ context }) =>
		requireAnyPermission({
			context,
			anyOf: ['chainConfig.manageQuickLinks', 'chainConfig.manageConfigPushes', 'chainConfig.manageBranding'],
			redirectTo: '/dashboard',
		}),
	validateSearch: searchSchema,
	component: ConfigPushHistoryPage,
});
